import { type OrganizationPublicKeyAudience } from "@api/types";

import { type Claim } from "../ClaimsList";
import { AUDIENCE_BACKSTAGE } from "./audiences";

const CLAIM_KID = "kid";
const CLAIM_ISS = "iss";
const CLAIM_JTI = "jti";
const CLAIM_IAT = "iat";
const CLAIM_SUB = "sub";
const CLAIM_EMAIL = "email";

const DESCRIPTION_KID = "Header. Give the key ID above.";
const DESCRIPTION_ISS = "Give the issuer above.";
const DESCRIPTION_JTI = "Give a different value for each token. The platform takes each value one time only, therefore a client cannot send one token again.";
const DESCRIPTION_IAT = "The time of the signature. A token is good for 5 minutes.";

const DESCRIPTION_SUB = "Give the ID of the investor in your own system, with a maximum of 48 characters. The platform binds that ID to the investor account at the first token, and each later token of that account must give the same ID.";
const DESCRIPTION_EMAIL = "Give the address of the investor. Your organization must already hold an investor account of that address.";

const COMMON_CLAIMS: Claim[] = [
  {
    name: CLAIM_KID,
    description: DESCRIPTION_KID,
  },
  {
    name: CLAIM_ISS,
    description: DESCRIPTION_ISS,
  },
  {
    name: CLAIM_JTI,
    description: DESCRIPTION_JTI,
  },
  {
    name: CLAIM_IAT,
    description: DESCRIPTION_IAT,
  },
];

const INVESTMENTS_CLAIMS: Claim[] = [
  {
    name: CLAIM_SUB,
    description: DESCRIPTION_SUB,
  },
  {
    name: CLAIM_EMAIL,
    description: DESCRIPTION_EMAIL,
  },
];

// NOTE: a key of the back office names its user in its own record, therefore
//       the assertion names no person and it carries the common claims only.
//       A key of the investor API asserts the investor, thus it carries the
//       sub claim and the email claim also.
const getClaims = (audience: OrganizationPublicKeyAudience): Claim[] => {
  const isBackstageAudience = audience === AUDIENCE_BACKSTAGE;

  if (isBackstageAudience) {
    return COMMON_CLAIMS;
  }

  const claims = [
    ...COMMON_CLAIMS,
    ...INVESTMENTS_CLAIMS,
  ];

  return claims;
};

export default getClaims;
